import { Link as RouterLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePlatformAuthStore } from '../store/platformAuthStore';
import { useUiStore } from '../store/uiStore';
import { useEffect, useState } from 'react';
import i18n from '../i18n/i18n';
import { ScrollableTabs } from '../ui/ScrollableTabs';

export function PlatformLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const admin = usePlatformAuthStore((s) => s.admin);
  const clear = usePlatformAuthStore((s) => s.clear);
  const locale = useUiStore((s) => s.locale);
  const setLocale = useUiStore((s) => s.setLocale);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    void i18n.changeLanguage(locale);
  }, [locale]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const activeTab =
    location.pathname.includes('/tenants')
      ? 'tenants'
      : location.pathname.includes('/settings')
        ? 'settings'
        : 'dashboard';

  return (
    <div className="platform-shell min-vh-100" style={{ background: 'var(--pk-bg)' }}>
      <header className="app-toolbar platform-toolbar">
        <button
          type="button"
          className="btn btn-icon btn-light d-md-none"
          aria-label="Menú"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <i className={`bi ${menuOpen ? 'bi-x-lg' : 'bi-list'} fs-5`} />
        </button>
        <strong className="text-white text-truncate me-2">{t('platform.brand')}</strong>
        <div className="flex-grow-1" />
        {admin ? (
          <span className="text-white-50 small d-none d-sm-inline me-2 text-truncate">
            {admin.email}
          </span>
        ) : null}
        <div className="btn-group me-1">
          <button
            type="button"
            className={`btn btn-sm ${locale === 'es' ? 'btn-primary' : 'btn-light'}`}
            onClick={() => setLocale('es')}
          >
            ES
          </button>
          <button
            type="button"
            className={`btn btn-sm ${locale === 'en' ? 'btn-primary' : 'btn-light'}`}
            onClick={() => setLocale('en')}
          >
            EN
          </button>
        </div>
        <button
          type="button"
          className="btn btn-light btn-sm"
          onClick={() => {
            clear();
            navigate('/platform/login');
          }}
        >
          <i className="bi bi-box-arrow-right" />
          <span className="d-none d-sm-inline ms-1">{t('nav.logout')}</span>
        </button>
      </header>

      <div className={`platform-nav-wrap ${menuOpen ? 'is-open' : ''}`}>
        <div className="platform-nav-inner d-none d-md-block px-3 pt-3">
          <ScrollableTabs
            activeId={activeTab}
            onChange={(id) => {
              if (id === 'dashboard') navigate('/platform');
              if (id === 'tenants') navigate('/platform/tenants');
              if (id === 'settings') navigate('/platform/settings');
            }}
            items={[
              { id: 'dashboard', label: t('platform.nav.dashboard') },
              { id: 'tenants', label: t('platform.nav.tenants') },
              { id: 'settings', label: t('platform.nav.settings') },
            ]}
          />
        </div>
        <div className="platform-nav-mobile d-md-none px-3 py-2">
          <RouterLink to="/platform" className="app-sidebar__link">
            <i className="bi bi-grid-1x2" />
            <span>{t('platform.nav.dashboard')}</span>
          </RouterLink>
          <RouterLink to="/platform/tenants" className="app-sidebar__link">
            <i className="bi bi-buildings" />
            <span>{t('platform.nav.tenants')}</span>
          </RouterLink>
          <RouterLink to="/platform/settings" className="app-sidebar__link">
            <i className="bi bi-gear" />
            <span>{t('platform.nav.settings')}</span>
          </RouterLink>
        </div>
      </div>

      <div className="app-content platform-content">
        <Outlet />
      </div>
    </div>
  );
}
